import { Typography } from '@global-engineering-shared/gweb-material-ui';
import React from 'react';

import ImportChipTextInput from 'features/Import/components/ImportDialog/components/ImportChipTextInput';
import useStyles from 'features/Import/components/ImportDialog/components/ImportDialogContent/ImportDialogContent.styles';

type ImportDialogContentProps = {
  setSpaceIds: React.Dispatch<React.SetStateAction<string[]>>;
};

const ImportDialogContent = ({ setSpaceIds }: ImportDialogContentProps) => {
  const classes = useStyles();

  const handleChipsChange = (newChips: string[]) => {
    setSpaceIds(newChips);
  };

  return (
    <div className={classes.root}>
      <Typography color="textPrimary" variant="body2">
        Select the SPACE IDs you wish to import into the inventory service.
      </Typography>
      <ImportChipTextInput onChipsChange={handleChipsChange} placeholder="Add SPACE IDs" />
    </div>
  );
};

export default ImportDialogContent;
